import lodash from "lodash";
import moment from "moment";
import {
    createFieldCheckbox,
    createFieldDate,
    createFieldInput,
    createFieldSelect,
    createFieldTextArea
} from "../../../components/input/template-builder/template-builder.logic";
import i18n from "../../../i18n";
import store from "../../../store";
import { conditionFormChecker, putField } from "../../../utils/form";
import { callDepartmentRandomSamplingDepartment } from "../sampling-monitor/sampling-monitor/sampling-monitor.section";

export const callCalendarType = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "CALENDAR_TYPE", value: searchQuery });

export const createField = ({ props, data, key /* , isLoading */ }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}isAllDay`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t("model.calendar.isAllDay"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            checked: model.isAllDay,
                            "onUpdate:checked": checked => {
                                model.isAllDay = checked;
                                if (checked) {
                                    if (model.startDatetime) {
                                        model.startDatetime = moment(model.startDatetime).format("YYYY-MM-DD[T]00:00:00Z");
                                    }
                                    if (model.endDatetime) {
                                        model.endDatetime = moment(model.endDatetime).format("YYYY-MM-DD[T]00:00:00Z");
                                    }
                                }
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}startDatetime`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t("model.calendar.startDatetime"),
                inputProp: ({ field }) => {
                    let format = "DD/MM/YYYY HH:mm";
                    let valueFormat = "YYYY-MM-DD[T]HH:mm:00Z";
                    let showTime = { format: "HH:mm" };
                    if (model.isAllDay) {
                        format = "DD/MM/YYYY";
                        valueFormat = "YYYY-MM-DD[T]00:00:00Z";
                        showTime = false;
                    }
                    return lodash.merge(
                        {
                            value: model.startDatetime,
                            "onUpdate:value": value => (model.startDatetime = value),
                            disabled: viewOnly,
                            format,
                            valueFormat,
                            showTime
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                }
            }),
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}endDatetime`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t("model.calendar.endDatetime"),
                inputProp: ({ field }) => {
                    let format = "DD/MM/YYYY HH:mm";
                    let valueFormat = "YYYY-MM-DD[T]HH:mm:00Z";
                    let showTime = { format: "HH:mm" };
                    if (model.isAllDay) {
                        format = "DD/MM/YYYY";
                        valueFormat = "YYYY-MM-DD[T]00:00:00Z";
                        showTime = false;
                    }
                    return lodash.merge(
                        {
                            value: model.endDatetime,
                            "onUpdate:value": value => (model.endDatetime = value),
                            disabled: viewOnly,
                            format,
                            valueFormat,
                            showTime
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refCalendarType`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t("model.calendar.refCalendarType"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refCalendarType,
                            "onUpdate:value": value => (model.refCalendarType = value),
                            disabled: viewOnly,
                            list: callCalendarType,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}name`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t("model.calendar.name"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.name,
                            "onUpdate:value": value => (model.name = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}desc`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t("model.calendar.desc"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.desc,
                            "onUpdate:value": value => (model.desc = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refDepartment`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t("model.calendar.refDepartment"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refDepartment,
                            "onUpdate:value": value => (model.refDepartment = value),
                            disabled: viewOnly,
                            list: callDepartmentRandomSamplingDepartment,
                            optLabel: "nameTh"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            })
        ]
    });
};
